<template>
  <div class="profile">
    <div v-if="isAuthLoading" class="profile__loader-wrapper">
      <ActionLoader color="#fff" :size="0.5" name="ball-pulse-sync" />
    </div>
    <template v-else>
      <div
        v-if="isAuthenticated"
        :class="[
          'profile__toggle-wrapper',
          isImpersonating && 'profile__impersonating',
        ]"
        @click="isMenuShown = !isMenuShown"
      >
        <button class="profile__toggle-btn" type="button">
          <img
            :src="currentAvatar"
            class="profile__image"
            alt="Icon representing the user"
          />
        </button>
        <ProfileToggler fill="#fff" class="profile__icon" />
      </div>
      <div class="profile__authenticate" v-else>
        <router-link
          class="btn__large profile__desktop-login"
          :to="{ name: 'login' }"
        >
          Log In
          <span class="material-icons btn__large-icon">person</span>
        </router-link>
        <router-link
          class="btn__action profile__mobile-login"
          :to="{ name: 'login' }"
        >
          Log In
          <span class="material-icons btn__action-icon">person</span>
        </router-link>
      </div>
    </template>
    <transition name="fade">
      <ProfileMenu
        v-if="isMenuShown"
        :profile="profile"
        :currentAvatar="currentAvatar"
        @closed="isMenuShown = false"
        @toggleWorkbooks="isWorkbooksShown = !isWorkbooksShown"
      />
    </transition>
    <Workbooks
      v-if="isWorkbooksShown"
      @toggleWorkbooks="isWorkbooksShown = false"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import ProfileToggler from '@/assets/icons/navigation/profile-toggler.svg'
import Workbooks from '@/components/navbar/Workbooks.vue'
import ProfileMenu from './ProfileMenu.vue'

export default {
  name: 'UserProfile',
  components: {
    ProfileToggler: { name: 'ProfileToggler', ...ProfileToggler },
    ProfileMenu,
    Workbooks,
    ActionLoader,
  },
  props: {
    isAuthenticated: {
      type: Boolean,
      required: true,
    },
    profile: {
      type: [Object, String],
      required: false,
    },
  },
  data() {
    return {
      isMenuShown: false,
      isWorkbooksShown: false,
    }
  },
  computed: {
    ...mapState({
      isAuthLoading: state => state.auth.isAuthLoading,
      isImpersonating: state => state.admin.isImpersonating,
      currentAvatar: state => state.auth.currentAvatar,
    }),
  },
}
</script>

<style lang="scss" scoped>
.profile {
  $this: &;
  &__loader-wrapper {
    margin: 0 50px 0 10px;
    padding: 0 12px 0 0;
    height: 40px;
  }
  &__impersonating {
    border: 5px solid red !important;
  }
  &__toggle-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 40px;
    border-radius: 25px;
    padding: 0 12px 0 0;
    background-color: transparent;
    @include tablet {
      background-color: rgba(0, 0, 0, 0.3);
    }
    &:hover {
      cursor: pointer;
      #{this}__toggle-btn {
        color: var(--orange);
      }
      #{this}__icon {
        fill: var(--orange);
      }
    }
  }
  &__toggle-btn {
    border: none;
    background: transparent;
    color: var(--white);
    font-size: 50px;
    transition: 0.5s all ease;
    margin: 15px 0 0 0;
    width: 40px;
    @include tablet {
      width: auto;
      margin: 15px -5px 0 -10px;
    }
    &:hover {
      cursor: pointer;
      #{this}__image {
        opacity: 0.8;
      }
    }
  }
  &__image {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    transition: 0.5s all ease;
  }
  &__icon {
    width: 40px;
    transition: 0.5s all ease;
    fill: var(--white);
    display: none;
    @include tablet {
      display: block;
    }
  }
  &__desktop-login {
    display: none;
    @include mobile {
      display: block;
    }
  }
  &__mobile-login {
    display: block;
    @include mobile {
      display: none;
    }
  }
  .btn__large {
    padding: 5px 40px 5px 10px;
    @include tablet {
      padding: 8px 50px 8px 10px;
    }
  }
  .btn__large-icon {
    top: -1px;
    @include tablet {
      top: 3px;
    }
  }
  .btn__action {
    font-size: 0.8rem;
  }
  .btn__action-icon {
    color: var(--white);
  }
}
</style>
